import React, { useState } from 'react'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'
import { AddressChange } from './AddressChange/AddressChange'
import './index.scss'
import { EmailChange } from './EmailChange/EmailChange'
import { PhoneChange } from './PhoneChange/PhoneChange'
import { Info } from './Info/Info'

export interface ISubmitCustomerInformation {
	customer: ICustomer
	formMeta: any
}

export type MyAccountPages = 'info' | 'address' | 'email' | 'phone'

export const ContactOtpLength = 6

// Keep in mind we are conditionally rendering different pages because of the burden of tech debt.
const MyAccount = () => {
	const [currentPage, setCurrentPage] = useState<MyAccountPages>('info')

	function handleGoBack() {
		setCurrentPage('info')
	}

	return (
		<div className="my-account fade-in container d-flex justify-content-center py-5">
			<div className="fixed-width">
				{currentPage === 'info' && (
					<Info onInfoClick={setCurrentPage} />
				)}

				{currentPage === 'address' && (
					<AddressChange onGoBack={handleGoBack} />
				)}
				{currentPage === 'phone' && (
					<PhoneChange onGoBack={handleGoBack} />
				)}
				{currentPage === 'email' && (
					<EmailChange onGoBack={handleGoBack} />
				)}
			</div>
		</div>
	)
}

export default MyAccount
